// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { EMBED, LISTED } = require("./ManageVideoConfig").default

export const embed = {
  icon: "play",
  title: "Embed a video",
  prompt: "From Vimeo, YouTube, Wistia, etc.",
  form: getContentFormContainer(EMBED)
}
export const listed = {
  icon: "file-video",
  title: "Reference an external video",
  prompt: "From a DVD, in class, etc.",
  form: getContentFormContainer(LISTED)
}
